// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.style-icon-size[data-v-0a9c90a7] {\n  height: 25px;\n  width: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
